import { BeforeYouStart } from './BeforeYouStart/BeforeYouStart';
import styles from './IntroducerOnboarding.module.css';

export const IntroducerOnboarding = () => {
  return (
    <div className={styles.pageContent}>
      <h2 className={styles.heading}>Sign up to be an iwoca introducer</h2>
      <div className={styles.listContainer}>
        <p>
          To complete this registration, you'll have to prepare a few documents:
        </p>
        <ul className={styles.list}>
          <li>
            <strong>Certified ID</strong> (e.g. valid passport or driving
            licence)
          </li>
          <li>
            <strong>Proof of business address</strong> (e.g. bank statements,
            utility bill, or a letter from HMRC or Companies House)
          </li>
          <li>
            <strong>Business bank statements</strong> (within the last 3 months)
          </li>
        </ul>
      </div>
      <BeforeYouStart />
    </div>
  );
};
